export const WHATSAPP_PBM_SIDEBAR_TITLE = 'Programa de Desconto';

export const WHATSAPP_PBM_PROGRAM_TYPE = 'WHATSAPP_PBM';

/** Usado quando o benefício não traz `Nome`. Hoje o fluxo é exclusivo da Lilly. */
export const WHATSAPP_PBM_DEFAULT_PROGRAM_NAME = 'Lilly';

export type WhatsappPbmStep = 'consent' | 'success' | 'error';
